import { FileInfo } from '@types'
import { getProxyUrl } from '.'

export async function uploadItem(
  fileInfo: FileInfo,
): Promise<{ success: boolean; message?: string }> {
  try {
    const formDataGLB = fileInfo.glbBase64

    const responseGLB = await fetch(getProxyUrl('api/unidades/uploadglb'), {
      method: 'POST',
      body: formDataGLB,
      headers: {
        'Content-Type': 'application/text',
        Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
      },
    })

    if (!responseGLB.ok) {
      const errorResponse = (await responseGLB.json()) as { detail?: string }
      return { success: false, message: errorResponse.detail || 'Error al subir el archivo GLB.' }
    }

    const filenameGlbPngTmp = (await responseGLB.text()) as string

    const formDataPNG = new FormData()
    formDataPNG.append('filenameGlbPngTmp', filenameGlbPngTmp)
    formDataPNG.append('png', fileInfo.pngBlob)

    const responsePNG = await fetch(getProxyUrl('api/unidades/uploadpng'), {
      method: 'POST',
      body: formDataPNG,
      headers: {
        Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
      },
    })

    if (!responsePNG.ok) {
      return { success: false, message: 'Error al subir el archivo PNG.' }
    }

    const importData = {
      FilenameGlbTmp: filenameGlbPngTmp,
      Ancho: fileInfo.width,
      Alto: fileInfo.height,
      Fondo: fileInfo.depth,
      Nombre: fileInfo.fileName,
      Referencia: fileInfo.reference,
      Descripcion: fileInfo.fileDescription,
      DescripcionLarga: fileInfo.longDescription,
      Precio: fileInfo.price,
      TipoNormalizado: fileInfo.tipoNormalizado,
      UrlProducto: fileInfo.url,
      MenuCarpeta: fileInfo.folder,
    }

    const responseImport = await fetch(getProxyUrl('api/unidades/importarUnidadUsuario'), {
      method: 'POST',
      body: JSON.stringify(importData),
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
      },
    })

    if (!responseImport.ok) {
      const errorResponse = (await responseImport.json()) as { detail?: string }
      return {
        success: false,
        message: errorResponse.detail || 'Error al importar la unidad de usuario.',
      }
    }

    return { success: true }
  } catch (error) {
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Error desconocido durante la operación.',
    }
  }
}
